import type { ComponentProps } from 'react'
import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import {
  Cards,
  Layout,
} from '@components/CategoriesBlock/CategoriesBlock.styles'
import { withI18next, withSkeletonTheme, withTheme } from '@hocs'
import { ImageCard } from '@velasca/ui/image-card'
import { MaxWidthContainer } from '@velasca/ui/max-width-container'

interface Page404AppParams {
  page404El: HTMLElement | null
  categoriesBlocksData: {
    imageCards?: ComponentProps<typeof ImageCard>[]
  }
}

export const renderPage404App = ({
  page404El,
  categoriesBlocksData,
}: Page404AppParams) => {
  if (page404El) {
    const Page404App = () => (
      <MaxWidthContainer>
        <Layout>
          {
            <Cards>
              {categoriesBlocksData.imageCards?.map((imageCard, i) => (
                <ImageCard key={i} {...imageCard} />
              ))}
            </Cards>
          }
        </Layout>
      </MaxWidthContainer>
    )

    const Page404AppWrapper = pipe(
      Page404App,
      withSkeletonTheme,
      withI18next,
      withTheme,
    )

    ReactDOM.createRoot(page404El).render(<Page404AppWrapper />)
  }
}
